// import loadingImg from '../assets/img/content/loading.gif';
import loadingImg from '../assets/img/content/loading-sm.gif';
const AppLoading = () => {
  return (
    <div className="container-fuild">
      <div className="appBGLoad loaderBg d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <img
          src={loadingImg} // Ensure this path is correct
          alt="Loading..."
          style={{ width: "60px", height: "60px" }} // set your desired size
        />
      </div>
    </div>
  );
};
export default AppLoading;
